import React from 'react';
import Link from '../../../../base/Link/Link';
import { Box } from '../../../../base/Box/Box';
import { HeaderNavLinksListStoryblok } from '../../../../types/storyblok';
import classNames from 'classnames';
import { Type } from '../../../../base/Type/Type';

export const HeaderNavLinksList = ({
  title,
  subLinks,
  className,
}: HeaderNavLinksListStoryblok) => {
  return (
    <Box as="li" className="group/list relative z-50 inline-block h-full py-3">
      <Box as="div" className={classNames('h-full w-full', className)}>
        <Type as="span" className="ff-type cursor-pointer text-p3">
          {title}
        </Type>
      </Box>
      <Box
        as="section"
        className={classNames('absolute hidden pt-4 group-hover/list:block')}
      >
        <Box
          as="ul"
          className="z-50 flex min-w-[200px] list-none flex-col gap-4 px-5 py-4 ff-black"
          overlayOverBkg
        >
          {subLinks?.map((link) => {
            const isInactiveLink = !link?.link?.url && !link?.link?.cached_url;

            return (
              <Box
                as="li"
                className={classNames(
                  'group/item flex items-center hover:opacity-80',
                  isInactiveLink && 'pointer-events-none opacity-60'
                )}
              >
                <Link href={link?.link} className="text-p3">
                  {link?.linkTitle}
                </Link>
                <Link
                  href={link?.link}
                  variant="naked-arrow-right"
                  className="inline-block pl-2 group-hover/item:translate-x-1"
                  empty
                />
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default HeaderNavLinksList;
